import { BACKDROP, CUSTOM_CLASS } from "../../utils/Constants";
import withReactContent from "sweetalert2-react-content";
import { momentFecha } from "../../utils/funciones";
import { Modal, Accordion } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import PropTypes from "prop-types";
import { Icono } from "./Iconos";
import Spinner from "./Spinner";
import Swal from "sweetalert2";

const modal = withReactContent(Swal);

const ArregloDocumentos = ({ data }) => {
  const arrKeys = Object.keys(data);

  return (
    <>
      {arrKeys.map((el, indx) => {
        const id = Number.parseInt(indx);
        return (
          <Accordion key={id}>
            <Accordion.Item eventKey={indx}>
              <Accordion.Header>
                {data[el].firmante.name}{" "}
                {Object.keys(data[el].errores).length > 0 ? (
                  <span style={{ marginLeft: "5px" }}>
                    <Icono iconName="noProcesado" />
                  </span>
                ) : (
                  ""
                )}
              </Accordion.Header>
              <Accordion.Body style={{ textAlign: "left", fontSize: "0.85rem" }}>
                {data[el].workflow && (
                  <div>
                    <strong>flujo de trabajo WebDox: </strong> {data[el].workflow}
                  </div>
                )}
                <div>
                  <strong>RUT colaborador: </strong> {data[el].firmante.national_identification_number}
                </div>
                <div>
                  <strong>Correo colaborador: </strong> {data[el].firmante.email ? data[el].firmante.email : <span style={{ color: "red" }}>No informado.</span>}
                </div>
                {data[el].errores && Object.keys(data[el].errores).length > 0 ? (
                  <div className="d-flex flex-column mt-2">
                    <strong className="text-center">Errores</strong>{" "}
                    {Object.keys(data[el].errores).map(key => (
                      <div key={key}>
                        <strong>{key}:</strong> {data[el].errores[key]}
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <div>
                      <strong>Fecha limite para la firma: </strong> {data[el].fechas ? momentFecha(data[el].fechas.fecha_limite) : "No hay información"}
                    </div>
                    <div className="text-start mt-3">
                      <strong>documentos envíados </strong>
                    </div>
                    <ListGroup as="ul">
                      {data[el].documentos.map((doc, indx) => (
                        <ListGroup.Item as="li" key={Number.parseInt(indx)}>
                          <div className="d-flex justify-content-between">
                            <span>{doc}</span>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        );
      })}
    </>
  );
};

ArregloDocumentos.propTypes = {
  data: PropTypes.object.isRequired,
};

export const detalleContratosEnviados = (icono, texto, data, llamarPagina, errors) => {
  const MySwal = withReactContent(Swal);

  MySwal.fire({
    title: texto,
    position: "center",
    showCloseButton: false,
    timerProgressBar: false,
    icon: errors === true ? "warning" : icono,
    html: <ArregloDocumentos data={data} />,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: true,
    confirmButtonText: "Entendido",
    toast: false,
    customClass: {
      popup: `popUpMensajeSimple ${icono}`,
    },
    backdrop: BACKDROP,
  }).then(async result => {
    if (result.isConfirmed) {
      llamarPagina();
    }
  });
};

const ListaPersonasOmitidas = ({ personas }) => {
  return (
    <div className="text-start mt-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
      <Accordion>
        {personas.map((persona, idx) => {
          const id = Number.parseFloat(idx);
          return (
            <Accordion.Item eventKey={idx} key={id}>
              <Accordion.Header>
                <span className="text-danger me-2">●</span>
                {persona.nombre} ({persona.rut})
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  <strong>Error:</strong> {persona.error}
                </div>
                {persona.contratos_omitidos && persona.contratos_omitidos.length > 0 && (
                  <div className="mt-1">
                    <strong>Contratos afectados:</strong>
                    <ul className="mb-0">
                      {persona.contratos_omitidos.map((c, i) => (
                        <li key={c}>{c}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

ListaPersonasOmitidas.propTypes = {
  personas: PropTypes.arrayOf(
    PropTypes.shape({
      nombre: PropTypes.string,
      rut: PropTypes.string,
      error: PropTypes.string,
      contratos_omitidos: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
};

ListaPersonasOmitidas.defaultProps = {
  personas: [],
};

export const detalleContratos = (icono, texto, data, llamarPagina) => {
  const MySwal = withReactContent(Swal);

  MySwal.fire({
    title: <h3>{icono === "success" ? "¡Éxito!" : "¡Atención!"}</h3>,
    position: "center",
    showCloseButton: false,
    timerProgressBar: false,
    icon: icono,
    html: (
      <div className="row mx-0">
        <div className="col-12">
          <h5>{texto}</h5>
        </div>
        {data && icono !== "success" && (
          <div className="col-12 mt-2">
            {typeof data === "object"
              ? Object.keys(data).length > 0 && (
                  <div className="mt-2">
                    <span className="text-muted d-block text-start mb-1">Respuesta del servicio (JSON):</span>
                    <pre
                      className="bg-light p-2 mb-0 text-start"
                      style={{
                        fontSize: "12px",
                        maxHeight: "300px",
                        overflowY: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-all",
                      }}
                    >
                      {JSON.stringify(data, null, 2)}
                    </pre>
                  </div>
                )
              : data.trim() !== "" && (
                  <>
                    <span className="text-muted">Respuesta del servicio:</span>
                    <h5>{data}</h5>
                  </>
                )}
          </div>
        )}
      </div>
    ),
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: true,
    confirmButtonText: "Entendido",
    toast: false,
    customClass: { popup: `popUpMensajeSimple ${icono}` },
    backdrop: BACKDROP,
  }).then(async result => {
    if (result.isConfirmed) {
      llamarPagina();
    }
  });
};

export const mensajeSimple = (icono, texto, tiempo = 3000) => {
  Swal.fire({
    position: "center",
    showCloseButton: false,
    timerProgressBar: true,
    icon: icono,
    title: texto,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    timer: tiempo,
    toast: false,
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      popup: `popUpMensajeSimple ${icono}`,
      timerProgressBar: "progressBarMensajeSimple mx-3",
    },
    backdrop: BACKDROP,
  });
};

export const mensajeEstatico = (icono, titulo, texto = "") => {
  Swal.fire({
    position: "center",
    icon: icono,
    title: titulo,
    text: texto,
    showConfirmButton: true,
    confirmButtonText: "Entendido",
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      popup: `popUpMensajeSimple ${icono}`,
      confirmButton: "btnSweetSolo",
    },
    buttonsStyling: false,
    backdrop: BACKDROP,
  });
};

export const mensajeCompleto = (icono, titulo = "", texto = "", tiempo = 2000) => {
  Swal.fire({
    position: "center",
    showCloseButton: false,
    icon: icono,
    title: titulo,
    text: texto,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    timer: tiempo,
    toast: false,
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      popup: `popUpMensajeSimple ${icono}`,
      timerProgressBar: "progressBarMensajeSimple mx-3",
    },
    backdrop: BACKDROP,
    timerProgressBar: true,
  });
};

export const modalComentario = (ejecutar, txtTitulo, data) => {
  const modal = withReactContent(Swal);

  modal
    .fire({
      icon: false,
      position: "center",
      input: "textarea",
      inputAttributes: {
        maxlength: 250
      },
      title: txtTitulo,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      allowEscapeKey: false,
      reverseButtons: false, // orden botones al reves
      customClass: CUSTOM_CLASS,
      backdrop: BACKDROP,
      buttonsStyling: false,
    })
    .then(async result => {
      if (result.isConfirmed) {
        ejecutar(data, false, false, result.value);
      }
    });
};

export const modalEjecutar = (ejecutar, txtTitulo, data) => {
  Swal.fire({
    icon: "info",
    position: "center",
    html: txtTitulo,
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Aceptar",
    allowEscapeKey: false,
    reverseButtons: false, // orden botones al reves
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar`,
      confirmButton: "btnCopec me-4",
      cancelButton: "btnAtras",
    },
    backdrop: BACKDROP,
    buttonsStyling: false,
  }).then(async result => {
    if (result.isConfirmed) {
      ejecutar(data);
    }
  });
};

export const modalDeclinarProceso = ejecutar => {
  const swalWithBootstrapButtons = Swal.mixin({});

  swalWithBootstrapButtons
    .fire({
      html: `
      ¿Está seguro que desea declinar el proceso?\n Se perderán los archivos cargados.`,
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      allowEscapeKey: false,
      reverseButtons: true, // orden botones al reves
      customClass: {
        container: "containerMensajeSimple",
        title: "titleMensajeSimple",
        text: "txtLabellInput",
        popup: `popUpSweetCancelarEnviar`,
        confirmButton: "btnCopec",
        cancelButton: "btnAtras",
      },
      backdrop: BACKDROP,
      buttonsStyling: false,
    })
    .then(async result => {
      if (result.isConfirmed) {
        ejecutar();
      }
    });
};

export const modalDeclinarSolicitud = (ejecutar, codPosicion, txtMsj) => {
  Swal.fire({
    icon: "warning",
    position: "center",
    html: txtMsj,
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    allowEscapeKey: false,
    confirmButtonText: "Declinar",
    reverseButtons: false, // orden botones al reves
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar`,
      confirmButton: "btnCopec me-4",
      cancelButton: "btnAtras",
    },
    backdrop: BACKDROP,
    buttonsStyling: false,
  }).then(async result => {
    if (result.isConfirmed) {
      modalCargando("Liberando posición...");
      ejecutar(codPosicion);
    }
  });
};

export const modalInfoCargoDeclinar = (ejecutar, msjInfo, codPosicion) => {
  Swal.fire({
    icon: "info",
    position: "center",
    html: `${msjInfo}`,
    showCancelButton: true,
    allowEscapeKey: false,
    cancelButtonText: "Cambiar Cargo",
    confirmButtonText: "Declinar",
    reverseButtons: true, // orden botones al reves
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar`,
      confirmButton: "btnCopec",
      cancelButton: "btnAtras",
    },
    backdrop: BACKDROP,
    buttonsStyling: false,
  }).then(async result => {
    if (result.isConfirmed) {
      modalDeclinarSolicitud(ejecutar, codPosicion);
    }
  });
};

const HtmlTitle = ({ texto = "" }) => <h3>{texto}</h3>;
HtmlTitle.propTypes = {
  texto: PropTypes.string,
};

export const HtmlList = ({ lista = [] }) => {
  return (
    <>
      <span className="h3">Guardando datos</span>
      <ul className="list-group">
        {lista.map((itm, indx) => {
          const id = Number.parseInt(indx);

          return (
            <li className="list-group-item d-flex justify-content-between" key={id}>
              <span>{itm.texto}</span>
              <img alt="icono" src={require(`../../../public/icon/${itm.icono}`)} width="20" height="20"></img>
            </li>
          );
        })}
      </ul>
    </>
  );
};

HtmlList.propTypes = {
  lista: PropTypes.arrayOf(
    PropTypes.shape({
      texto: PropTypes.string,
      icono: PropTypes.string,
    }),
  ),
};

export const HtmlProgresBar = ({ valueNow, valueMax }) => {
  return (
    <>
      <div className="mt-3 d-flex justify-content-center">
        <h4>
          Enviando {valueNow} de {valueMax}
        </h4>
      </div>
      <div className="progress mb-4 mx-4">
        <div className="progress-bar progressBarMensajeSimple" style={{ width: `${Number.parseInt((valueNow / valueMax) * 100)}%` }} aria-valuenow={valueNow} aria-valuemin={0} aria-valuemax={valueMax}></div>
      </div>
    </>
  );
};

HtmlProgresBar.propTypes = {
  valueNow: PropTypes.number.isRequired,
  valueMax: PropTypes.number.isRequired,
};

const cfgModal = {
  showConfirmButton: false,
  position: "center",
  showCancelButton: false,
  allowOutsideClick: false,
  allowEscapeKey: false,
  customClass: {
    container: "containerMensajeSimple",
    title: "titleModalCargando",
    text: "txtLabellInput",
    popup: `popUpSweetCancelarEnviar pt-4 pb-5 h1`,
  },
  backdrop: BACKDROP,
  didOpen: () => {
    Swal.showLoading();
  },
};

export const ModalEnviandoSAP = ({ actual, max, visibleModal }) => {
  return (
    <Modal centered show={visibleModal}>
      <div className="text-center">
        <Spinner />
        <HtmlProgresBar valueNow={actual} valueMax={max} />
      </div>
    </Modal>
  );
};

ModalEnviandoSAP.propTypes = {
  actual: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  visibleModal: PropTypes.bool.isRequired,
};

export const ModalEnviandoContratos = ({ actual, max, contratoName, infoContrato, visibleModal }) => {
  return (
    <Modal centered show={visibleModal}>
      <div className="text-center">
        <Spinner />
        <HtmlProgresBar valueNow={actual} valueMax={max} />
        <div className="text-center">
          <h6>
            {contratoName}: {infoContrato}
          </h6>
        </div>
      </div>
    </Modal>
  );
};

ModalEnviandoContratos.propTypes = {
  actual: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  contratoName: PropTypes.string.isRequired,
  infoContrato: PropTypes.string,
  visibleModal: PropTypes.bool.isRequired,
};

export const modalCargando = (textMsj = "") => {
  modal.fire({
    showConfirmButton: false,
    position: "center",
    html: <HtmlTitle texto={textMsj} />,
    showCancelButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      container: "containerMensajeSimple",
      title: "titleModalCargando",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar pt-4 pb-5 h1`,
    },
    backdrop: BACKDROP,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

//e export const modalGuardando = (list = [], htmlComponent = <HtmlList />) => {
//e   const modal = withReactContent(Swal);
//e   modal.fire({
//e     position: "center",
//e     showConfirmButton: false,
//e     showCancelButton: false,
//e     html: htmlComponent,
//e     customClass: {
//e       container: "containerMensajeSimple",
//e       title: "titleModalCargando",
//e       text: "txtLabellInput",
//e       popup: `popUpSweetCancelarEnviar pt-4 pb-5 h1`,
//e     },
//e     backdrop: BACKDROP,
//e     didOpen: () => {
//e       Swal.showLoading();
//e     },
//e   });
//e };

export const HtmlListHistorial = ({ lista = [] }) => {
  return (
    <>
      {lista.map((el, indx) => {
        const id = Number.parseInt(indx);

        return (
          <div className="cardContrato text-start mb-2 py-1 px-2" key={id}>
            <p className="my-0">
              <b className="me-1">Responsable:</b> {el.responsable}
            </p>
            <p className="my-0">
              <b className="me-1">Estado:</b> {el.nombre_estado}
            </p>
            <p className="my-0">
              <b className="me-1">Observación:</b> {el.observaciones}
            </p>
            <p className="my-0">
              <b className="me-1">Fecha:</b> {momentFecha(el.fecha.split(" ")[0])}
            </p>
          </div>
        );
      })}
    </>
  );
};

HtmlListHistorial.propTypes = {
  lista: PropTypes.arrayOf(
    PropTypes.shape({
      responsable: PropTypes.string,
      nombre_estado: PropTypes.string,
      observaciones: PropTypes.string,
      fecha: PropTypes.string,
    }),
  ),
};

export const modalHistorial = (titulo = "serysryreye", list = []) => {
  const modal = withReactContent(Swal);
  modal.fire({
    position: "center",
    title: titulo,
    showConfirmButton: true,
    showCancelButton: false,
    confirmButtonText: "Entendido",
    html: <HtmlListHistorial lista={list} />,
    customClass: {
      container: "containerMensajeSimple",
      title: "titleModalCargando",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar pt-2 pb-5 h1`,
      confirmButton: "btnSweetSolo",
    },
    buttonsStyling: false,
    backdrop: BACKDROP,
  });
};

export const modalShowSAP = obj => {
  const modal = withReactContent(Swal);
  modal.fire({
    position: "top",
    showConfirmButton: false,
    title: "Solicitudes no enviadas",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: true,
    buttonsStyling: false,
    cancelButtonText: "Entendido",
    html: (
      <>
        {obj.map((el, indx) => {
          return (
            <div className="accordion" id={`accordionExample${indx}`} key={el.idSolicitud}>
              <div className="accordion-item">
                <h2 className="accordion-header" id={`headingOne${indx}`}>
                  <button className="accordion-button h2 mb-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${indx}`} aria-expanded="false" aria-controls={`collapseOne${indx}`}>
                    Nro - {el.idSolicitud}
                  </button>
                </h2>
                <div id={`collapseOne${indx}`} className="accordion-collapse collapse" aria-labelledby={`headingOne${indx}`} data-bs-parent={`accordionExample${indx}`}>
                  <div className="accordion-body p-1">
                    <pre>
                      <code>
                        <b className="me-1" style={{ minWidth: "fit-content" }}>
                          Repuesta SAP:
                        </b>
                        {el["respuesta SAP"]}
                      </code>
                      <hr className="m-1" />
                      <code>{JSON.stringify(el.solicitud, null, 2)}</code>
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    ),
    customClass: {
      container: "containerMensajeSimple",
      title: "titleModalCargando pt-0",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar pt-4 pb-3 h1`,
      cancelButton: "btnAtras",
    },
    backdrop: BACKDROP,
  });
};

const DatosSolicitante = ({ nombre, identificacion, motivo_ingreso, fecha_baja }) => {
  return (
    <>
      <h3 className="mb-4">Detalles solicitud</h3>
      <p>
        <b className="me-1">Nombre:</b>
        {nombre.split(" ")[0] + " " + nombre.split(" ")[1]}
      </p>
      <p>
        <b className="me-1">Apellido paterno:</b>
        {nombre.split(" ")[2]}
      </p>
      <p>
        <b className="me-1">Apellido materno:</b>
        {nombre.split(" ")[3] || "---"}
      </p>
      <p>
        <b className="me-1">Rut:</b>
        {identificacion}
      </p>
      <p>
        <b className="me-1">Motivo de reingreso:</b>
        {motivo_ingreso}
      </p>
      <p>
        <b className="me-1">Fecha de baja:</b>
        {fecha_baja}
      </p>
    </>
  );
};

DatosSolicitante.propTypes = {
  nombre: PropTypes.string.isRequired,
  identificacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  motivo_ingreso: PropTypes.string,
  fecha_baja: PropTypes.string,
};

export const modalReingresoOpciones = solicitante => {
  console.log({ solicitante });

  const modal = withReactContent(Swal);
  modal.fire({
    position: "center",
    html: <DatosSolicitante {...solicitante} />,
    confirmButtonText: "Ok",
    allowEscapeKey: true,
    reverseButtons: true, // orden botones al reves
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar`,
      confirmButton: "btnSweetSolo",
      htmlContainer: "contHtmlModalReingreso",
    },
    backdrop: BACKDROP,
    buttonsStyling: false,
  });
};

export const modalReingresoAccion = async (vacante, ejecutar, titulo, opcionAccion) => {
  Swal.fire({
    input: "textarea",
    title: titulo,
    inputPlaceholder: `Motivo...`,
    inputAttributes: { "aria-label": "Type your message here", maxlength: 250 },
    reverseButtons: false, // orden botones al reves
    customClass: {
      container: "containerMensajeSimple",
      title: "titleMensajeSimple",
      text: "txtLabellInput",
      popup: `popUpSweetCancelarEnviar`,
      confirmButton: "btnSweetSolo me-4",
      cancelButton: "btnAtras",
    },
    buttonsStyling: false,
    confirmButtonText: opcionAccion === 1 ? "Aceptar" : "Rechazar",
    cancelButtonText: `Cancelar`,
    backdrop: BACKDROP,
    showCancelButton: true,
  }).then(result => {
    if (result.isConfirmed) {
      const body = {
        ...{ params: { idSolicitud: vacante.id } },
        ...{ data: { comentario: result.value, resolucion: opcionAccion } },
      }; // 1 aceptado, 2 rechazado
      modalEjecutar(ejecutar, `¿Está seguro de ${opcionAccion === 1 ? "aceptar" : "rechazar"} este reingreso?`, body);
    } else if (result.isDenied) {
      Swal.close();
    }
  });
};

const HtmlContrato = ({ ejecutar, contratos }) => {
  return (
    <>
      <h3 className="mb-3">Revisión de contrato</h3>
      <div className="contenedorCardsModal">
        {contratos.map((el, indx) => {
          const id = Number.parseInt(indx);
          return (
            <div className="cardContrato mb-2 py-1 px-2" key={id}>
              <p className="my-0">
                <b className="me-1">Nombre:</b> {el.Nombre}
              </p>
              <p className="my-0">
                <b className="me-1">División:</b> {el.Division}
              </p>
              <p className="my-0">
                <b className="me-1">Cargo:</b> {el.Cargo}
              </p>
              <p className="my-0">
                <b className="me-1">Plan de horario:</b> {el.Phtd}
              </p>
              <p className="my-0">
                <b className="me-1">Nombre:</b> {el.Nombre}
              </p>
              <p className="my-0">
                <b className="me-1">Unidad organizativa:</b> {el.TextoUnidadOrganizativa}
              </p>
              <p className="my-0">
                <b className="me-1">Documento:</b> {el.NombrePlantilla}
              </p>
            </div>
          );
        })}
      </div>
      <div className="d-flex justify-start flex-column mt-3">
        <b htmlFor="inputMotivo" className="text-start">
          Motivo
        </b>
      </div>
    </>
  );
};

HtmlContrato.propTypes = {
  ejecutar: PropTypes.func.isRequired,
  contratos: PropTypes.array.isRequired,
};

export const modalAprobarRechazarContrato = (contratos, resolucionContrato) => {
  let motivoModif = txt => txt;
  const arrayIdContratos = lista => {
    return lista.map(el => ({ id: el.id.toString(), nombre: el.Nombre }));
  };
  const modal = withReactContent(Swal);
  modal
    .fire({
      input: "textarea",
      position: "center",
      showConfirmButton: true,
      showCancelButton: false,
      showDenyButton: true,
      showCloseButton: true,
      allowOutsideClick: true,
      reverseButtons: false,
      allowEscapeKey: true,
      buttonsStyling: false,
      html: <HtmlContrato ejecutar={motivoModif} contratos={contratos} />,
      denyButtonText: "Rechazar",
      confirmButtonText: "Aceptar",
      customClass: {
        container: "containerMensajeSimple",
        title: "titleMensajeSimple",
        input: "form-control mt-0 inputMotivo pt-1",
        text: "txtLabellInput",
        popup: `popUpSweetCancelarEnviar`,
        confirmButton: "btnCopec me-4 mt-1",
        denyButton: "btnAtras",
        htmlContainer: "contHtmlModalReingreso mt-2 mb-0",
        closeButton: "btnCerrarModal",
      },
      backdrop: BACKDROP,
    })
    .then(result => {
      if (result.isConfirmed) {
        modalEjecutar(resolucionContrato, "Se procederá a aceptar estos documentos. ¿Desea Continuar?", {
          idContrato: arrayIdContratos(contratos),
          respuesta: "1",
          motivo: result.value,
        });
      }
      if (result.isDenied) {
        modalEjecutar(resolucionContrato, "Se procederá a rechazar estos documentos. ¿Desea Continuar? ", {
          idContrato: arrayIdContratos(contratos),
          respuesta: "2",
          motivo: document.querySelector(".inputMotivo").value,
        });
      }
    });
};

export const ModalVerNotificaciones = ({ visible = false, lista = [] }) => {
  return (
    <Modal show={visible} lista={lista}>
      <div>vaina</div>
    </Modal>
  );
};

ModalVerNotificaciones.propTypes = {
  visible: PropTypes.bool,
  lista: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export const modalAccionConMensaje = async (
  accion = () => {
    alert("Sin accion a ejecutar");
  },
  titulo = "Sin titulo",
  tituloEspera = "Sin titulo de espera",
) => {
  const { value: text } = await Swal.fire({
    input: "textarea",
    inputPlaceholder: "Escribe tu motivo...",
    inputAttributes: { "aria-label": "Type your message here", maxlength: 250 },
    title: titulo,
    reverseButtons: false,
    cancelButtonText: "Cancelar",
    confirmButtonText: "Declinar",
    customClass: CUSTOM_CLASS,
    backdrop: BACKDROP,
    showCancelButton: true,
    allowOutsideClick: false,
    buttonsStyling: false,
  });

  if (text) {
    alert(text);
  }
};
